import * as React from 'react';
import { SecondaryNavClick } from '../../../store/action/secondaryNavActions';
import './SecondaryNav.css';
import { PROFILE, RESULTS } from '../../../store/constants';
import { faAngleDoubleRight, faAngleDoubleLeft }  from '@fortawesome/fontawesome-free-solid';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
const logo = require('./../../../../src/assets/img/logo.svg');

interface Props {
    next: SecondaryNavClick;
    previous: SecondaryNavClick;
    loading: boolean;
    navId: string;
    previousDisabled: boolean;
    nextDisabled: boolean;
}

class SecondaryNav extends React.Component<Props> {
    static openLink(url: string) {
        window.open(url, '_blank');
    }

    render() {
        const {
            next,
            previous,
            previousDisabled,
            nextDisabled,
            navId
        } = this.props;

        const showBackButton = navId !== PROFILE;
        const showNextButton = navId !== RESULTS;
        const isResultsPage = navId === RESULTS;

        const contactMeLink = 'https://iianalytics.com/services/benchmarking';
        const downloadReportLink = 'https://iianalytics.com/analytics-resources/ranking-analytics-maturity-by-industry';
        const IIAHomepageLink = 'https://wwww.iianalytics.com';

        return (
            <nav className="secondary-nav-wrapper">
                <a href="https://www.iianalytics.com">
                    <img src={logo} alt="Logo" className="secondary-nav-logo" />
                </a>
                <div className="button-wrapper">
                    { showBackButton &&
                        <button
                            className="previous-button"
                            disabled={previousDisabled}
                            onClick={previous}
                        >
                            <FontAwesomeIcon icon={faAngleDoubleLeft} />
                            Back
                        </button>
                    }
                    {showNextButton &&
                        <button
                            className="next-button"
                            disabled={nextDisabled}
                            onClick={next}
                        >
                            Next
                            <FontAwesomeIcon icon={faAngleDoubleRight}/>
                        </button>
                    }
                    { isResultsPage &&
                        <button
                            className="previous-button smaller-text"
                            disabled={false}
                            onClick={() => SecondaryNav.openLink(IIAHomepageLink)}
                        >
                            IIA Home
                        </button>
                    }
                    { isResultsPage &&
                        <button
                            className="previous-button smaller-text"
                            disabled={false}
                            onClick={() => SecondaryNav.openLink(contactMeLink)}
                        >
                            Contact Me
                        </button>
                        }
                    { isResultsPage &&
                        <button
                            className="previous-button smaller-text"
                            disabled={false}
                            onClick={() => SecondaryNav.openLink(downloadReportLink)}
                        >
                            Download Report
                        </button>
                    }
                </div>
            </nav>
        );
    }
}

export default SecondaryNav;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/nav/bottomNav/SecondaryNav.tsx